import '../../styles/SpeakerItem.css';
import Icons from '../community/Icons';
import profileImage from '../../assets/images/community/speaker.jpeg';

function SpeakerItem({ firstName, lastName }) {

    return (
        <div className='speakerCard-item'>
            <div className='speakerCard-item__description'>
                <div className='speakerCard-item-image'>
                    <img src={profileImage} />
                </div>
            
                <h2>{firstName} {lastName}</h2>
            </div>
            <div>
                <Icons />
            </div>
        </div>
    );
}

export default SpeakerItem;